(function () {
  "use strict";

  var root = document.documentElement;

  // Aucune animation si l'utilisateur préfère la sobriété, ni dans l'éditeur de thème.
  var prefersReduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced || root.classList.contains("shopify-design-mode")) {
    return;
  }

  var main = document.getElementById("MainContent");
  if (!main || !("IntersectionObserver" in window)) {
    return;
  }

  var ITEM = ".product-grid__item, .resource-list__item";
  var TEXT = ".text-block, .button, .button-secondary, .button-custom";
  var PARALLAX = ".media-with-content .media-block img";
  // Un peu plus que la plus longue transition (délai + durée) avant de nettoyer.
  var SETTLE_MS = 2800;
  var tagged = [];

  try {
    setupReveal();
  } catch (error) {
    // En cas de problème, on retire tout : le site reste affiché normalement.
    tagged.forEach(clean);
  }

  try {
    setupParallax();
  } catch (error) {
    // La parallâxe est un bonus : si elle échoue, les images restent simplement fixes.
  }

  /* ---------- Carrousel « Notre sélection » : images prêtes avant d'entrer à l'écran ---------- */

  // Les images du carrousel défilant sont chargées tout de suite (jamais en « lazy ») et décodées d'avance,
  // pour qu'une carte n'ait pas à être décodée au moment précis où elle glisse à l'écran.
  window.addEventListener("load", function () {
    try {
      var pictures = main.querySelectorAll("product-marquee img");
      for (var i = 0; i < pictures.length; i++) {
        if (pictures[i].loading === "lazy") pictures[i].loading = "eager";
        if (pictures[i].decode) pictures[i].decode().catch(function () {});
      }
    } catch (error) {
      // Simple renfort : en cas de souci, les images se chargent normalement.
    }
  });

  /* ---------- Apparition au scroll ---------- */

  function setupReveal() {
    var sections = main.querySelectorAll(".shopify-section");
    var viewportHeight = window.innerHeight;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          reveal(entry.target);
        });
      },
      // Déclenche un peu avant que la section n'entre franchement dans l'écran.
      { root: null, rootMargin: "0px 0px -8% 0px", threshold: 0 }
    );

    sections.forEach(function (el) {
      // Tout ce qui est déjà à l'écran (hero compris) reste tel quel :
      // aucun masquage, aucun retard, aucun impact sur le chargement.
      if (el.getBoundingClientRect().top < viewportHeight) return;

      tag(el);
      observer.observe(el);
    });
  }

  // Prépare une section : choisit son mode et numérote ses textes / boutons.
  function tag(section) {
    // Le carrousel « Notre sélection » défile en continu : ses cartes ne sont jamais animées une à une
    // (opacité, translation, zoom par carte) ; seule la section se révèle, d'un bloc.
    var hasItems = !!section.querySelector(ITEM) && !section.querySelector("product-marquee");
    var texts = section.querySelectorAll(TEXT);
    var order = 0;

    for (var i = 0; i < texts.length; i++) {
      var node = texts[i];
      // Les textes des cartes suivent la carte, ils ne bougent pas seuls.
      if (node.closest(ITEM) || node.closest("product-card") || node.closest("[data-da-r]")) continue;
      node.setAttribute("data-da-r", "");
      node.style.setProperty("--da-r", Math.min(order++, 5));
    }

    section.setAttribute(
      "data-scroll-reveal",
      hasItems ? "cards" : order > 0 ? "stack" : "section"
    );
    tagged.push(section);
  }

  function reveal(section) {
    if (section.getAttribute("data-scroll-reveal") === "cards") {
      stagger(section);
    }
    section.classList.add("is-visible");
    window.setTimeout(function () {
      clean(section);
    }, SETTLE_MS);
  }

  // Décalage en cascade uniquement pour les cartes réellement visibles à l'écran ;
  // celles hors champ (carrousel, bas de grille) apparaissent sans attente.
  function stagger(section) {
    var items = section.querySelectorAll(ITEM);
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var order = 0;

    for (var i = 0; i < items.length; i++) {
      var rect = items[i].getBoundingClientRect();
      var inView = rect.top < vh && rect.bottom > 0 && rect.left < vw && rect.right > 0;
      items[i].style.setProperty("--da-i", inView ? Math.min(order++, 5) : 0);
    }
  }

  // Une fois l'animation terminée (ou en cas d'erreur), on retire tous les marqueurs :
  // plus aucun transform, délai ou opacité résiduels sur la page.
  function clean(section) {
    var nodes = section.querySelectorAll("[data-da-r], " + ITEM);
    section.removeAttribute("data-scroll-reveal");
    section.classList.remove("is-visible");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].removeAttribute("data-da-r");
      nodes[i].style.removeProperty("--da-r");
      nodes[i].style.removeProperty("--da-i");
    }
  }

  /* ---------- Parallaxe légère ---------- */

  // L'image d'une section « média + texte » glisse très doucement à l'intérieur de son cadre
  // pendant le scroll. Seul `translate` est modifié : pas de recalcul de mise en page.
  function setupParallax() {
    var firstSection = main.querySelector(".shopify-section");
    var images = main.querySelectorAll(PARALLAX);
    var active = [];

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target._daVisible = entry.isIntersecting;
        });
        schedule();
      },
      { root: null, rootMargin: "20% 0px 20% 0px", threshold: 0 }
    );

    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var frame = img.closest(".media-block");
      // Le hero (première section) n'est jamais concerné.
      if (!frame || (firstSection && firstSection.contains(img))) continue;

      img._daFrame = frame;
      img._daVisible = false;
      img.setAttribute("data-da-parallax", "");
      active.push(img);
      observer.observe(img);
    }

    if (!active.length) return;

    var ticking = false;

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var amplitude = window.innerWidth < 750 ? 0.035 : 0.05;

      for (var j = 0; j < active.length; j++) {
        var el = active[j];
        if (!el._daVisible || el._daOff) continue;

        // Si l'image ne remplit pas tout son cadre, on n'y touche pas (pas de bord vide).
        if (el.clientHeight < el._daFrame.clientHeight - 2) {
          el._daOff = true;
          el.removeAttribute("data-da-parallax");
          el.style.removeProperty("translate");
          continue;
        }

        var rect = el._daFrame.getBoundingClientRect();
        if (!rect.height) continue;

        // progress : -1 (cadre au-dessus de l'écran) … 0 (centré) … 1 (en dessous)
        var progress = (rect.top + rect.height / 2 - vh / 2) / ((vh + rect.height) / 2);
        progress = Math.max(-1, Math.min(1, progress));
        el.style.translate = "0 " + (-progress * rect.height * amplitude).toFixed(1) + "px";
      }
    }

    // `capture` : on écoute aussi le défilement du conteneur de page (version ordinateur).
    document.addEventListener("scroll", schedule, { passive: true, capture: true });
    window.addEventListener("resize", schedule, { passive: true });
    schedule();
  }
})();